module.exports = __webpack_public_path__ + "img/user.8e014ea9.jpg";